import {createFileRoute} from "@tanstack/react-router";
import Review from "@/modules/reviews/review";
import {Authorisation} from "@/lib/auth/components/auth-provider";
import {ROLES} from "@/lib/auth/roles";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {REVIEW_PATH} from "@/utils/urls";

export const Route = createFileRoute(REVIEW_PATH)({
  component: RouteComponent,
  loader: async ({params}) => {
    const {id} = params

    return {id}
  },
  beforeLoad: ({params}) => {
    return {
      breadcrumbs: [
        {label: 'Reviews', path: '#'},
        {label: `${params.id}`, path: `/v2/reviews/${params.id}`}
      ],
      children: null,
      canSwitchFirm: false
    }
  },
})

function RouteComponent() {
  return (
    <div className={'flex flex-col items-left justify-center max-sm:p-5'}>
      <Authorisation
        roles={[
          ROLES.ROLE_VIEW_FIRM,
          ROLES.ROLE_EDIT_FIRM,
        ]}
        permissions={[]}
        forbiddenFallback={<Unauthorized/>}
      >
        <Review/>
      </Authorisation>
    </div>
  )
}